import React from 'react';
import { Box } from "@mui/material";
import BackHeader from "../Components/BackHeader";

const Fan = () => {
    return (
        <>
            <BackHeader marginBottom={0} marginLeft={-15} />
            <Box
                sx={{
                    position: 'relative',
                    width: '100vw',
                    height: '100vh',
                    mx: 'calc(-50vw + 50%)',
                    overflow: 'hidden',
                    bgcolor: 'black', // background black
                }}
            >
                <Box
                    component="video"
                    autoPlay
                    controls
                    controlsList="nodownload"
                    loop
                    sx={{
                        position: 'absolute',
                        top: 0,
                        left: 0,
                        width: '100%',
                        height: '100%',
                        objectFit: 'contain', // full video dikhega
                        backgroundColor: 'black',
                    }}
                >
                    <source
                        src="https://kbeanprod.blob.core.windows.net/public-beta/kbean%20web%20video.mp4"
                        type="video/mp4"
                    />
                    Your browser does not support the video tag.
                </Box>

            </Box>
        </>
    );
};

export default Fan;
